export default __webpack_public_path__ + "static/media/burger-meat.1e12c39a.svg";